"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatCurrency = formatCurrency;
var _constants = require("../constants");
var _getFormattedCurrency = require("../internals/getFormattedCurrency");
/**
 * Returns parameter `value` formatted as the currency.
 *
 * The `value` is formatted in the runtime culture in case:
 * - the {@link culture} setting is not provided,
 * - the currency formatting rules or currency pattern are not available in the {@link culture} setting.
 *
 * @param value Numeric value to format
 * @param culture Culture settings containing formatting rules
 * @param financialSet Financial settings containing currency specification
 * @param options Additional formatting options
 * @returns `value` formatted as the currency
 * @example
  // basic usage
  import { formatCurrency, useCulture } from '@ori/culture';
  const { culture, financialSet } = useCulture();
  const formattedCurrency = formatCurrency(1234.567, culture, financialSet);

  // use a custom delimiter
  formatCurrency(1234.567, culture, financialSet, { doubleCurrencyDelimiter: ' | ' });
 */
// eslint-disable-next-line max-params -- needed for formatting
function formatCurrency(value, culture, financialSet, options) {
  const {
    currencies
  } = (0, _getFormattedCurrency.getFormattedCurrency)(value, culture, financialSet);
  return currencies.filter(Boolean).join(options?.doubleCurrencyDelimiter ?? _constants.DEFAULT_DOUBLE_CURRENCY_DELIMITER);
}
//# sourceMappingURL=formatCurrency.js.map